import React, { useState, useEffect, useCallback } from 'react';
import { ArrowLeft, Wrench, FileAudio, Download, Music, ChevronRight, Headphones } from 'lucide-react';
import { authFetch, fmtAr } from './utile/utileApi';
import Mp3Tool from './utile/Mp3Tool';
import DownloadTool from './utile/DownloadTool';
import SongTool from './utile/SongTool';

// ============================================================
// TeckiA Utile : boîte à outils. Chaque bouton ouvre un outil.
//   Vidéo -> MP3 (gratuit) · Télécharger une vidéo Facebook/YouTube (gratuit) · Lien Facebook/YouTube -> MP3 seulement (gratuit)
//   · Créer / transformer une chanson (portefeuille)
// ============================================================

const LinkMp3Tool = (props) => <DownloadTool {...props} audio />;

const TOOLS = [
  { key: 'mp3', title: 'Vidéo en MP3', desc: "Extrait uniquement le son d'une vidéo", icon: FileAudio, grad: 'from-emerald-500 to-teal-500', Comp: Mp3Tool },
  { key: 'download', title: 'Télécharger une vidéo', desc: 'Depuis un lien Facebook ou YouTube : la vidéo complète, en MP4', icon: Download, grad: 'from-sky-500 to-indigo-500', Comp: DownloadTool },
  { key: 'linkmp3', title: 'Lien en MP3', desc: 'Depuis un lien Facebook ou YouTube : le son seulement, en MP3', icon: Headphones, grad: 'from-teal-500 to-cyan-500', Comp: LinkMp3Tool },
  { key: 'song', title: 'Créer une chanson', desc: 'Créez un titre ou transformez une chanson existante', icon: Music, grad: 'from-fuchsia-500 to-purple-600', Comp: SongTool },
];

export default function Utile({ onBack }) {
  const [tool, setTool] = useState(null);
  const [status, setStatus] = useState(null);

  const reload = useCallback(async () => {
    try {
      const r = await authFetch('/api/utile/status');
      const d = await r.json();
      if (d.success) setStatus(d);
    } catch (_) { /* statut indisponible : les outils restent utilisables */ }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const current = TOOLS.find(t => t.key === tool);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-900 text-white">
      <div className="max-w-3xl mx-auto px-4 py-6 md:py-10">
        <div className="flex items-center gap-3 mb-6">
          <button onClick={current ? () => setTool(null) : onBack} className="p-2.5 rounded-xl bg-white/10 hover:bg-white/20 transition">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold flex items-center gap-2.5">
              <span className={`w-10 h-10 rounded-2xl bg-gradient-to-br ${current ? current.grad : 'from-amber-500 to-orange-600'} flex items-center justify-center shadow-lg`}>
                {current ? <current.icon className="w-5 h-5" /> : <Wrench className="w-5 h-5" />}
              </span>
              {current ? current.title : 'TeckiA Utile'}
            </h1>
            <p className="text-sm text-blue-200 mt-0.5">{current ? current.desc : 'Des outils pratiques, tout-en-un'}</p>
          </div>
        </div>

        {!current && (
          <div className="space-y-3">
            {TOOLS.map(t => (
              <button key={t.key} onClick={() => setTool(t.key)}
                className="w-full text-left rounded-3xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/30 transition p-5 flex items-center gap-4">
                <span className={`w-14 h-14 shrink-0 rounded-2xl bg-gradient-to-br ${t.grad} flex items-center justify-center shadow-lg`}><t.icon className="w-6 h-6" /></span>
                <span className="flex-1 min-w-0">
                  <span className="block font-bold text-lg">{t.title}</span>
                  <span className="block text-sm text-blue-200">{t.desc}</span>
                  <span className="block text-xs mt-1 text-gray-400">
                    {t.key === 'song' ? (status ? `Solde ${fmtAr(status.balance)} · ${fmtAr(status.song_price_ar)} la création` : 'Paiement par portefeuille') : 'Gratuit'}
                  </span>
                </span>
                <ChevronRight className="w-5 h-5 text-gray-400 shrink-0" />
              </button>
            ))}
          </div>
        )}

        {current && <current.Comp status={status} reload={reload} />}
      </div>
    </div>
  );
}
